import { apiRequest } from "@/services/api-client";
import {
  UpdatePlayerProfileInput,
  UpdatePlayerProfileOutput,
} from "types/web-app";

export const updatePlayerProfile = (input: UpdatePlayerProfileInput) =>
  apiRequest<UpdatePlayerProfileOutput>("/update-player-profile", {
    method: "POST",
    body: JSON.stringify(input),
  });
